import React from "react";
import "./CallHomepage.scss";
import useContactUs from "../../../hooks/useContactUs";
import phoneIcon from "../../../assets/phone-icon.png";

const CallHomepage = () => {
  const [contactUs] = useContactUs();

  return (
    <>
      <div className="call_homepage">
        <div className="container">
          <div className="call_content">
            <div className="row justify-content-between">
              <div className="col-lg-5 my-auto">
                <div className="left" data-aos="fade-right">
                  <h4>
                    NOT SURE WHAT YOU NEED? <br /> FIND AN AGENT NOW.
                  </h4>
                  <p>
                    If you are looking for more information about the choices
                    available to you, our friendly team is here to answer any
                    questions you may have.
                  </p>
                </div>
              </div>
              <div
                className="col-lg-6 mt-5 mt-lg-0"
                data-aos="flip-left"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="1000"
              >
                <div className="call_card">
                  <div className="left_text">
                    <img src={phoneIcon} alt="" />
                    <h5 className="my-3">Contact Number:</h5>
                    <h5 className="mb-4" style={{ color: "#D31145" }}>
                      +{contactUs.ContactNo}
                    </h5>
                    <a
                      className="btn main_btn"
                      href="tel:{contactUs.ContactNo}"
                      rel=""
                    >
                      <span className="btn_text">Call Now</span>
                    </a>
                  </div>
                  <div className="right_text"></div>

                  {/* <div className="d-flex justify-content-center">
                    <div>
                      <img src={phoneIcon} alt="" />
                    </div>{" "}
                    <div className="ms-3">
                      <h5>Call Now:</h5>
                      <h4>+02223385625-6</h4>
                      <a
                        href="https://www.google.com/"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Google
                      </a>
                    </div>
                  </div> */}
                  {/* <div className="text-center my-3">
                    <Link to="https://www.google.com/">
                      <button className="btn main_btn w-lg-25">
                        <span className="btn_text">contAct US</span>
                      </button>
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallHomepage;
